import {ApiService} from "@/services";
import {APIConfig} from "@/constants";

const requirementGathering = (payload: any) => {
    return ApiService[APIConfig.REQUIREMENT_GATHERING.METHOD](APIConfig.REQUIREMENT_GATHERING.URL, payload);
}

const add_user_Subscription = ( payload: any)=>{
    return ApiService[APIConfig.ADD_USER_SUBSCRIPTION.METHOD](APIConfig.ADD_USER_SUBSCRIPTION.URL, payload);
}

const uploadAsset = ( payload: any) =>{
    return ApiService[APIConfig.UPLOAD_ASSET.METHOD](APIConfig.UPLOAD_ASSET.URL, payload);
}

const forkApp = ( payload: any)=>{
    return ApiService[APIConfig.FORK_APP.METHOD](APIConfig.FORK_APP.URL, payload);
}


const saveRoleSelection = ( payload: any )=>{
    return ApiService[APIConfig.SAVE_ROLE_SELECTION.METHOD](APIConfig.SAVE_ROLE_SELECTION.URL, payload);
}

const getSupabaseLoginUrl = (payload: any) => {
    return ApiService[APIConfig.GET_SUPABASE_LOGIN_URL.METHOD](APIConfig.GET_SUPABASE_LOGIN_URL.URL, payload)
}

const generateAppPromptFromSummary = (payload: any) => {
    return ApiService[APIConfig.GENERATE_APP_PROMPT_FROM_SUMMARY.METHOD](APIConfig.GENERATE_APP_PROMPT_FROM_SUMMARY.URL, payload);
}


const AgentService = {
    requirementGathering,
    add_user_Subscription,
    uploadAsset,
    forkApp,
    saveRoleSelection,
    getSupabaseLoginUrl,
    generateAppPromptFromSummary
}

export default AgentService;
